import { Link } from "@tanstack/react-router";

import { ErrorAlert } from "../components/ui/alert";
import { Card, CardDescription, CardTitle } from "../components/ui/card";

export function NotFoundPage() {
  return (
    <main className="mx-auto max-w-md px-4 py-16">
      <Card>
        <CardTitle>Page not found</CardTitle>
        <CardDescription>This page does not exist.</CardDescription>
        <Link to="/" className="mt-4 inline-block text-sm text-primary hover:underline">
          Go to the dashboard
        </Link>
      </Card>
    </main>
  );
}

export function ForbiddenPage() {
  return (
    <Card>
      <CardTitle>You don't have access to this page</CardTitle>
      <CardDescription>Ask an administrator if you need it.</CardDescription>
    </Card>
  );
}

export function ErrorPage({ error }: { error: unknown }) {
  return (
    <main className="mx-auto max-w-md px-4 py-16">
      <Card>
        <CardTitle>Something went wrong</CardTitle>
        <ErrorAlert className="mt-4" error={error} />
        <a href="/" className="mt-4 inline-block text-sm text-primary hover:underline">
          Reload the app
        </a>
      </Card>
    </main>
  );
}
